// extracted by mini-css-extract-plugin
module.exports = {"edit-dropdown-container":"ActivityManagement_edit-dropdown-container__3Mk_T","block-tiny-line":"ActivityManagement_block-tiny-line__16obI"};